import {
  EMPTY_RESOURCE,
  DummyResourceImg,
  RESOURCES_TITLES
} from 'utils/constants/resources';
import { removeDuplicates } from '.';
import { ChartsInfo } from 'store/chartsInfo/chartsInfo.slice';
import { ResourcesArr, IResourceCard } from 'interfaces/components/resources';
import { ChartSwitches } from 'interfaces/store/chartFilters';

const defaultResourcesMap = (resources: ResourcesArr[]): IResourceCard[] =>
  resources.map(resource => ({
    url: resource?.URL || '',
    text: resource?.TITLE || '',
    image: resource?.IMAGE_URL || DummyResourceImg
  }));

export const mapTopInsights = (resources: ResourcesArr[]): IResourceCard[] =>
  defaultResourcesMap(
    resources.filter(resource => resource.URL && resource.TITLE).slice(0, 4)
  );

export const mapForYouResources = (
  resources: ResourcesArr[],
  currentARR: number | null,
  chartSwitches: ChartSwitches,
  chartsInfo: ChartsInfo
): IResourceCard[] => {
  const forYouResources: IResourceCard[] = [];
  const allResources = defaultResourcesMap(resources);

  const selectedChartTitle =
    chartsInfo.chartsData[chartsInfo.selectedChartIndex]?.title;

  const findResource = (title: string) =>
    allResources.find(resource => resource.text === title) || EMPTY_RESOURCE;

  // Default resources
  RESOURCES_TITLES.slice(0, 8).forEach((title, index) => {
    forYouResources[index] = findResource(title);
  });

  // Third priority resources - based on selected chart
  if (selectedChartTitle) {
    if (
      selectedChartTitle === 'YoY ARR Growth' ||
      selectedChartTitle === 'Gross New ARR Composition' ||
      selectedChartTitle === 'New Logo Velocity'
    ) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[1]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[9]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[8]));
    } else if (selectedChartTitle === 'Quick Ratio') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[5]));
    } else if (
      selectedChartTitle === 'Gross Dollar Retention' ||
      selectedChartTitle === 'Net Dollar Retention'
    ) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[4]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[5]));
    } else if (
      selectedChartTitle === 'Net Magic Number' ||
      selectedChartTitle === 'CAC Payback'
    ) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[11]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[10]));
    } else if (selectedChartTitle === 'Rule of 40') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[4]));
    } else if (selectedChartTitle === 'Burn Multiple') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[13]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[12]));
    } else if (selectedChartTitle === 'OpEx as a % of Revenue') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[15]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[14]));
    } else if (selectedChartTitle === 'Gross Margin') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[7]));
    } else if (selectedChartTitle === 'FCF Margin') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[4]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[15]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[14]));
    } else if (
      selectedChartTitle === 'Headcount Distribution' ||
      selectedChartTitle === 'ARR per FTE'
    ) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[17]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[16]));
    } else if (selectedChartTitle === 'OpEx per FTE') {
      forYouResources.unshift(findResource(RESOURCES_TITLES[13]));
      forYouResources.unshift(findResource(RESOURCES_TITLES[12]));
    }
  }

  // Second priority resources - based on chart switches
  if (!chartSwitches.timeDurationSwitch) {
    forYouResources.unshift(findResource(RESOURCES_TITLES[7]));
    forYouResources.unshift(findResource(RESOURCES_TITLES[6]));
    forYouResources.unshift(findResource(RESOURCES_TITLES[5]));
  }

  if (!chartSwitches.xAxisSwitch) {
    forYouResources.unshift(findResource(RESOURCES_TITLES[4]));
  }

  // First priority resources - based on Current ARR user input
  if (currentARR) {
    if (currentARR < 20000000) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[1]));
    } else if (currentARR > 200000000) {
      forYouResources.unshift(findResource(RESOURCES_TITLES[4]));
    }
  }

  return removeDuplicates(forYouResources, 'text')
    .filter(resource => resource.image && resource.text && resource.url)
    .slice(0, 4);
};
